module.exports = __webpack_public_path__ + "static/img/logo.798a977d.png";